import { BaseHttpProvider } from "./base";
import { DataProcessingProtocol } from "../processor";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { take } from 'rxjs/operators';

export abstract class PostProvider<T> extends BaseHttpProvider<T> {
  constructor(public http: HttpClient) {
    super();
  }

  /**
   * @override
   * Disable caching for all post calls
   */
  get isCachable() {
    return false;
  }

  /**
   * Generate a post observable and
   */
  protected generateBaseObservable(
    body: string,
    urlSearchParams?: HttpParams
  ): Observable<any> {
    var token =
      this.authProtocol != null && this.authProtocol != undefined
        ? this.authProtocol.getToken()
        : null;
    var post;
    var userToken;
    if (token instanceof Observable) {
      token.pipe(take(1)).subscribe(user => {
        if (user != null) userToken = user.token;
        else userToken = null;
        post = this.http.post(this.endpoint, body, {
          headers: this.getHeaders(userToken),
          params: urlSearchParams
        });
      });
    } else {
      post = this.http.post(this.endpoint, body, {
        headers: this.getHeaders(token),
        params: urlSearchParams
      });
    }
    return post;
  }
}

/**
 * Sample implementations
 */
export abstract class BasePostProvider<T> extends PostProvider<T>
  implements DataProcessingProtocol {
  constructor(public http: HttpClient) {
    super(http);
    this.processingDelegate = this;
  }

  processResponse(response: any) {
    if (!(response instanceof Array)) response = [response];

    var datas = [];
    for (var data of response) {
      var modelObj = new this.model().deserialize(data);
      datas.push(modelObj);
    }

    return datas;
  }
}

export abstract class BaseEavPostProvider<T> extends PostProvider<T>
  implements DataProcessingProtocol {
  constructor(public http: HttpClient) {
    super(http);
    this.processingDelegate = this;
  }

  processResponse(response: any) {
    let data = new this.model().eavDeserialize(response.attribute);

    return data;
  }
}
